export const getAvailableModalMaxHeight = (occupiedHeight, initialMaxHeight = 400) => {
    const windowHeight = window.innerHeight;
    return Math.floor(Math.min(windowHeight * 0.8 - (occupiedHeight || 20), initialMaxHeight));
};
